
/**
 * Loader API Version: 2
 * Is this in "webpack mode": true
 */
export default {
  "title": "Charge History",
  "subtitle": "Past Charge",
  "id": "ID",
  "description": "Description",
  "status": "Status",
  "created": "Date",
  "amount": "Amount",
  "receipt": "Receipt",
  "showAll": "Show All",
  "hideAll": "Show Less",
  "showingRecent": "Showing your 5 most recent charges",
  "showingAll": "Showing all charges"
}
